export const PHASES = {
    BIG: 'BIG',
    MEGA: 'MEGA',
    SUPER_MEGA: 'SUPER_MEGA',
    EPIC: 'EPIC'
};

export const ASSETS = {
    POPUP: 'spine-big_win_popup',
    BACKGROUND: 'img-background_big_win'
}

export const ANIMATION_DURATION = {
    HIDE_POPUP: 0.6,
    HIDE_CHARACTER: 0.2,
    SHOW_WIN_LABEL: 0.25
};

export const SPINE_EVENTS = {
    CHANGE_SKIN: 'change_rays_color',
    SHOW_CHARACTER: 'character_appear'
}

export const ANIMATIONS = {
    SHOW: 'appear',
    BIG: {
        IDLE: 'big_idle',
        HIDE: 'big_out'
    },
    MEGA: {
        IDLE: 'mega_idle',
        HIDE: 'mega_out'
    },
    SUPER_MEGA: {
        IDLE: 'super_mega_idle',
        HIDE: 'super_mega_out'
    },
    EPIC: {
        IDLE: 'epic_idle',
        HIDE: 'epic_out'
    },
    TRANSITIONS: {
        MEGA: 'transition_1',
        SUPER_MEGA: 'transition_2',
        EPIC: 'transition_3'
    }
};

export const SKINS = {
    BIG: 'rays_blue',
    MEGA: 'rays_green',
    SUPER_MEGA: 'rays_yellow',
    EPIC: 'rays_red'
}

export const CHARACTERS = {
    BIG: 'spine-symbol_h2',
    MEGA: 'spine-symbol_h3',
    SUPER_MEGA: 'spine-symbol_h4',
    EPIC: 'spine-symbol_h5'
}

export const MULTIPLIER_STAGES = {
    BIG: 20,
    MEGA: 50,
    SUPER_MEGA: 100,
    EPIC: 250
};

export const MAX_MULTIPLIER = {
    BIG: 50,
    MEGA: 100,
    SUPER_MEGA: 250,
    EPIC: 10000
};

export const SOUNDS = {
    COUNTER: "win_count_sound",
    BIG: "big_win_updated",
    MEGA: "mega_win",
    SUPER_MEGA: "super_mega_win",
    EPIC: "epic_win",
}

export const CHARACTER_POSITION_Y = {
    BIG: 182,
    MEGA: 182,
    SUPER_MEGA: 160,
    EPIC: 120,
}

export const BITMAP_FONT = {
    ALIAS: 'font_2',
    ALIGN: 'center',
}